import React, { useEffect, useState } from "react";
import { Card, Table } from "reactstrap";

const UserActions = (props) => {
  const [userActionsArray, setUserActionsArray] = useState([-1]);
  const [userId, setUserId] = useState(props.userId);

  const loadUserActions = () => {
    // only try to fetch for a valid user
    if(!userId) {
      return;
    }

    fetch("/api/user/fetch-user-actions/" + userId)
      .then(res => res.json())
      .then(res => setUserActionsArray(res));
  };

  useEffect(()=>{
    if(props.userId) {
      loadUserActions(); // re-fetch actions for this user
    }
  },[userId]);

  return (
    <div className="text-center">
      <Card className="p-2 mt-1">
        {
          userActionsArray.length === 0 ?
          (<span>No actions logged yet.</span>) :
          (<div>
            {
            userActionsArray.length === 0 || userActionsArray[0] === -1 ?
              (<span>No actions logged yet.</span>) :
              (
              <div>
                <span>Actions Logged: : </span>
                <Table className="table=sm mt-2">
                  <tbody>
                    {userActionsArray.map((userAction) => (
                      <tr>
                        <td className="text-left">{userAction.actionName}</td>
                        <td className="text-left">API used: {userAction.apiUsed}</td>
                        <td className="text-left">{new Date(userAction.createdOn).toUTCString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              )
            }
          </div>)
        }
      </Card>
    </div>
  );
};

export default UserActions;
